import React from "react";
import Routes from "./routes";
import "@fontsource/montserrat"; // Regular
import "@fontsource/montserrat/500.css"; // Medium
import "@fontsource/montserrat/700.css"; // Bold
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FloatingWhatsApp from "./components/floatingWhatsapp/floatingWhatsApp";
import "./App.css";

const App = () => (
  <>
    <Routes />;
    <FloatingWhatsApp /> {/* 👈 Always visible */}
  </>
);

export default App;
